/*eslint-disable*/
import React from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { OKTA_BASE_REDIRECT_URI } from '../../okta/okta.constants'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslation } from 'react-i18next'

export default function Logout() {
  const { oktaAuth } = useOktaAuth()
  const { t } = useTranslation()
  oktaAuth.signOut({
    postLogoutRedirectUri: `${OKTA_BASE_REDIRECT_URI}`
  })

  return (
    <div style={{
      width: '100vw',
      display: 'flex',
      justifyContent: 'center',
      height: '75vh',
      alignItems: 'center',
    }}
    >
      <div style={{
        textAlign: 'center',
      }}>
        <CircularProgress style={{verticalAlign: 'middle'}} color="error" data-testid="spinner" />
        <div>{t('signing-out')} </div>
      </div>
    </div>

  )
}
